import styled from 'styled-components';
import { getSpacing, typography } from 'stylesheet';

export const FormRowContainer = styled.div`
  > * {
    flex: 0.7;
    &:first-child {
      margin-right: ${getSpacing(3)};
    }
  }
  margin-bottom: ${getSpacing(1)};
`;

export const ButtonsContainer = styled.div`
  margin-top: ${getSpacing(5)};
  display: flex;
  justify-content: flex-end;
`;
export const SettingsFormContainer = styled.div`
  margin-top: ${getSpacing(5)};
`;

export const PaymentMethodRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${getSpacing(3)};
  margin-bottom: ${getSpacing(1)};
  > label:first-child {
    min-width: 160px;
  }
`;

export const AllowedPaymentMethodsLabel = styled.p`
  margin: 0 0 ${getSpacing(1)};
  ${typography.p1_bold}
`;
